import { AutoMap } from "@automapper/classes";

export class PrelevementAirDTO {
    @AutoMap()
    type!: number;
    @AutoMap()
    referenceTube!: string;
    @AutoMap()
    duree!: number;
    @AutoMap()
    resultat!: string;
    @AutoMap()
    conformite!: boolean;
}